//includes the necessary UI bundles as well as their dependencies
//jquery,moment,daterangepicker,bootstrap
import $ from 'jquery'
window.jQuery = $; window.$ = $
import moment from "moment"
window.moment = moment
import "@/js/lib/daterangepicker.js"
import "@/js/lib/bootstrap.bundle.min.js"